// extracted by mini-css-extract-plugin
export var cardHeader = "_rv-0";
export var reorderHandle = "_rv-3";
export var titleArea = "_rv-1";
export var titleAreaWithHandle = "_rv-2";